import type { SVGProps } from "react";
export interface Numer4CircleIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Numer4CircleIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Numer4CircleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 12a8.875 8.875 0 1 0-17.75 0 8.875 8.875 0 0 0 17.75 0m2.25 0c0 6.144-4.98 11.124-11.124 11.125S.875 18.145.875 12 5.856.875 12.001.875c6.143 0 11.124 4.981 11.124 11.126Z"
      />
      <path
        fill={color}
        d="M12.126 16v-.626H9.5a1.374 1.374 0 0 1-1.174-2.088l3.5-5.75.149-.204c.796-.916 2.4-.384 2.4.919v4.873h.376l.115.006a1.126 1.126 0 0 1 0 2.24l-.115.004h-.375V16a1.125 1.125 0 0 1-2.25 0m-1.068-2.876h1.068v-1.753z"
      />
    </svg>
  );
}
